import { render, staticRenderFns } from "./shetai.vue?vue&type=template&id=1bdd83d2&"
import script from "./shetai.vue?vue&type=script&lang=ts&"
export * from "./shetai.vue?vue&type=script&lang=ts&"
import style0 from "./shetai.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports